module.exports = __webpack_public_path__ + "static/media/Binomial_CRR.e73e4d2d.png";